export default function getEnv(key: string): string | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }
  // eslint-disable-next-line no-underscore-dangle
  return (window as Window & { __env?: Record<string, string> }).__env?.[key];
}
